import EventEmitter from "./base/EventEmitter";
import FormValidator from "./base/FormValidator";

export default class Questionnaire extends EventEmitter {

    constructor($element) {
        super();

        this.$element = $element;

        this.$backButton = this.$element.find('.js-cancel');

        this.$progressBar = this.$element.find('.js-progress-bar');

        this.bindEvents();
    }

    bindEvents() {
        let me = this;

        let $forms = this.getStepForms();

        if (['/apprenticeships/apprentices/questionnaire/', '/apprenticeships/apprentices/questionnaire'].indexOf(window.location.pathname) !== -1) {
            this.$backButton.hide();
        }

        $forms.each((index, form) => {
            let $form = $(form);

            let validator = FormValidator.attach($form, {
                inputOptions: {
                    messages: {
                        unchecked: "Please select one of the options above.",
                    },
                },
            });

            validator.on("submit", (form) => {
                let $form = $(form);
                let data = $form.serializeJSON();

                if ((typeof data.choice) === 'undefined') {
                    $form.find('.js-message-holder').append(
                        eotwJSXFactory('div', {className: "message message--error"}, ["Something went wrong when trying to complete the form, please try again."]),
                    );
                    return true;
                }

                let $answer = $form.find('.question__input[name="choice"]:checked');

                if ($answer.is('[data-result]')) {
                    this.showResult(data.choice);
                } else {
                    this.setStep(data.choice);
                }
            });
        });

        this.$element.on('click', '.js-continue', function () {
            //get active form and submit it
            let $form = me.getActiveForm();
            $form.find('.js-message-holder').html('');
            $form.submit();
        }).on('click', '.js-cancel', function () {
            //get active form and submit it
            let step = $(this).attr('data-step');

            if (step.trim() !== '') {
                me.setStep(step);
            } else {
                me.emit('questionnaire.cancel');
            }
        }).on('click', '.js-retry', function (e) {
            e.preventDefault();
            me.resetForm();
        });
    }

    resetOptions() {
        this.$element.find('input[type="radio"]').prop('checked', false);
    }

    resetForm() {
        this.resetOptions();
        this.hideResult();
        this.setStep('initial');
    }

    setStep(name) {
        let $currentStep = this.getActiveStep();

        let $newStep = this.$element.find('.questionnaire__step[data-step="' + name + '"]');
        let previousStep = $newStep.attr('data-previous-step');
        let percentage = parseInt($newStep.attr('data-progress')) / 100;

        this.updateProgress(percentage);
        this.updateBackButton(name, previousStep);

        $currentStep.removeClass('questionnaire__step--active');
        this.$element.find('.questionnaire__step[data-step="' + name + '"]').addClass('questionnaire__step--active');
    }

    updateBackButton(name, previousStep) {
        //Update cancel/go back button
        this.$backButton.attr('data-step', (typeof previousStep) !== 'undefined' ? previousStep : '');
        this.$backButton.show();

        if (name === 'initial') {
            this.$backButton.text('Cancel');
            if (['/apprenticeships/apprentices/questionnaire/', '/apprenticeships/apprentices/questionnaire'].indexOf(window.location.pathname) !== -1) {
                this.$backButton.hide();
            }
        } else {
            this.$backButton.text('Go Back');
        }
    }

    getActiveStep() {
        return this.$element.find('.js-step.questionnaire__step--active');
    }

    getActiveForm() {
        return this.$element.find('.js-step.questionnaire__step--active .js-step-form');
    }

    getStepForms() {
        return this.$element.find(".js-step-form");
    }

    hideResult() {
        this.$element.removeClass('questionnaire--result');
    }

    showResult(result) {
        this.updateProgress(1);

        let results = {
            computers: [
                {
                    title: 'Product Design & Development Technician',
                    text: 'Improving product performance and efficiency while researching and developing new manufacturing ideas and systems.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/product-design-development-technician/',
                }, {
                    title: 'Machinist',
                    text: 'Create, install, maintain and repair metal products, including machinery and equipment in factories.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/machinist/',
                },
            ],
            tools_machines: [
                {
                    title: 'Toolmaker and Tool & Die Maintenance Technician',
                    text: 'Highly skilled engineers that carry out complex and specialist detailed work.Highly skilled engineers that carry out complex and specialist detailed work.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/toolmaker-and-tool-die-maintenance-technician/',
                }, {
                    title: 'Machinist',
                    text: 'Create, install, maintain and repair metal products, including machinery and equipment in factories.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/machinist/',
                },
            ],
            technical_support: [
                {
                    title: 'Technical Support Technician',
                    text: 'Providing technical support and expertise for all areas of engineering and manufacturing functions.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/technical-support-technician/',
                },
            ],
            mechanical: [
                {
                    title: 'Mechatronic (Mechanical Maintenance)',
                    text: 'Ensuring that mechanical plant and equipment perform to the required standards.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/mechatronics-maintenance-technician/',
                },
            ],
            electrical: [
                {
                    title: 'Mechatronic (Electrical Maintenance)',
                    text: 'Ensuring that electrical equipment perform to the required standards.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/mechatronics-maintenance-technician/',
                },
            ],
            both: [
                {
                    title: 'Mechatronic (Multi Skilled)',
                    text: 'Ensuring that plant and equipment perform to the required standards.',
                    url: '/apprenticeships/apprentices/apprenticeship-types/mechatronics-maintenance-technician/',
                },
            ],
        };

        result = (typeof results[result]) !== 'undefined' ? results[result] : [];


        let $resultsHolder = this.$element.find('.js-results');

        $resultsHolder.html('');

        result.forEach((pathway) => {
            $resultsHolder.append(
                eotwJSXFactory('div', {className: "questionnaire__pathway"}, [
                    eotwJSXFactory('div', {className: "questionnaire__pathway-content"}, [
                        eotwJSXFactory('h3', {className: "heading heading--4"}, [(typeof pathway.title) !== 'undefined' ? pathway.title : '']),
                        eotwJSXFactory('p', null, [(typeof pathway.text) !== 'undefined' ? pathway.text : ''])
                    ]),
                    eotwJSXFactory('a', {href: (typeof pathway.url) !== 'undefined' ? pathway.url : '', className: "btn btn--primary"}, ["Find out about this pathway"])
                ]),
            );
        });

        this.$element.addClass('questionnaire--result');
    }

    updateProgress(value) {
        this.$progressBar.css({transform: "scaleX(" + value + ")"});
    }
}
